import React from 'react';
import { MessageCircle } from 'lucide-react';

const WhatsAppButton = () => {
  const whatsappUrl = 'https://wa.me/905441181827?text=Hi%20GlowMeets,%20I%20would%20like%20to%20plan%20an%20event';

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-float"
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle size={30} color="#FFFFFF" />
    </a>
  );
};

export default WhatsAppButton;
